import getLogoHeight from "@/lib/helpers/getLogoHeight";
import getLogoWidth from "@/lib/helpers/getLogoWidth";
import { LogoPropsType } from "@/lib/main";

export default function Logo({
  className,
  handleClick,
  name,
  size,
}: LogoPropsType) {
  if (!name) name = "blue";
  if (!size) size = "md";

  const getWidth = getLogoWidth(name, size);
  const getHeight = getLogoHeight(name, size);

  switch (name) {
    case "blue":
      return (
        <svg
          style={{ minHeight: getHeight, minWidth: getWidth }}
          className={className}
          onClick={handleClick}
          width={getWidth}
          height={getHeight}
          viewBox="0 0 79 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M74.127 11.6631V7.29492H69.082L66.7441 4.95703V2.3291L69.082 0H70.4004V4.13965H75.7617L78.0205 6.47754V9.33398L75.6914 11.6631H74.127ZM71.0156 2.10059V0H75.6826L77.7041 2.03027V3.26953H74.127V2.10059H71.0156ZM66.7441 8.16504H70.6289V9.55371H73.5117V11.6631H68.7041L66.7441 9.33398V8.16504Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M55.7754 11.6631V0H59.6602V11.6631H55.7754ZM60.2754 11.6631V9.33398H62.2002V7.85742H65.7246V11.6631H60.2754Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M50.2471 10.3887H46.4326L47.2412 8.07715H49.3506L46.2305 0H50.0186L54.668 11.6631H50.7393L50.2471 10.3887ZM45.3955 11.6631H41.6426L45.8086 0.527344L47.5312 5.15918L45.3955 11.6631Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M26.3584 0H30.4893L33.6182 5.18555L36.0791 0.966797V6.83789L33.2754 11.6631L26.3584 0ZM36.6504 11.6631V0H40.5352V11.6631H36.6504ZM26.3496 11.6631V1.08105L29.9795 7.17188V11.6631H26.3496Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M20.8213 10.3887H17.0068L17.8154 8.07715H19.9248L16.8047 0H20.5928L25.2422 11.6631H21.3135L20.8213 10.3887ZM15.9697 11.6631H12.2168L16.3828 0.527344L18.1055 5.15918L15.9697 11.6631Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M3.88477 9.33398H7.21582V11.6631H2.3291L0 9.33398V2.3291L2.3291 0H3.88477V9.33398ZM5.94141 5.19434H11.2764V11.6631H7.83105V7.50586H5.94141V5.19434ZM4.5 2.3291V0H9.2373L11.2764 2.3291V3.49805H7.3916V2.3291H4.5Z"
            fill="var(--color-brand-primary)"
          />
        </svg>
      );

    case "blue-ar":
      return (
        <svg
          style={{ minHeight: getHeight, minWidth: getWidth }}
          className={className}
          onClick={handleClick}
          width={getWidth}
          height={getHeight}
          viewBox="0 0 42 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.6186 14.98C26.6186 14.7373 26.7026 14.5413 26.8706 14.392C27.0199 14.224 27.2159 14.14 27.4586 14.14H41.2066C41.2066 14.5693 41.1226 14.9707 40.9546 15.344C40.8053 15.7173 40.5906 16.044 40.3106 16.324C40.0306 16.604 39.7039 16.828 39.3306 16.996C38.9573 17.1453 38.5559 17.22 38.1266 17.22H27.4586C27.2159 17.22 27.0199 17.1453 26.8706 16.996C26.7026 16.828 26.6186 16.6227 26.6186 16.38V14.98ZM33.9266 7.98L39.6666 13.72H35.3266L32.6386 11.06H28.8586V7.98H33.9266ZM32.0506 20.664L33.9266 18.788L35.8026 20.664L33.9266 22.54L32.0506 20.664Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M16.8131 7.98H19.8931C20.7331 7.98 21.5265 8.148 22.2731 8.484C23.0198 8.80133 23.6731 9.24 24.2331 9.8C24.7931 10.36 25.2318 11.0133 25.5491 11.76C25.8851 12.5067 26.0531 13.3 26.0531 14.14V17.22H22.9731V14.14C22.9731 13.7107 22.8891 13.3093 22.7211 12.936C22.5718 12.5627 22.3571 12.236 22.0771 11.956C21.7971 11.676 21.4705 11.4613 21.0971 11.312C20.7238 11.144 20.3225 11.06 19.8931 11.06V13.72H16.8131V7.98ZM22.5531 14.14V17.22H14.8531C14.6105 17.22 14.4145 17.1453 14.2651 16.996C14.0971 16.828 14.0131 16.6227 14.0131 16.38V14.98C14.0131 14.7373 14.0971 14.5413 14.2651 14.392C14.4145 14.224 14.6105 14.14 14.8531 14.14H22.5531ZM26.4731 14.14H27.4531V17.22H26.4731V14.14Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M9.81312 0H12.8931V13.72H9.81312V0ZM7.85312 17.22C7.61046 17.22 7.41446 17.1453 7.26512 16.996C7.09712 16.828 7.01312 16.6227 7.01312 16.38V14.98C7.01312 14.7373 7.09712 14.5413 7.26512 14.392C7.41446 14.224 7.61046 14.14 7.85312 14.14H14.8531V17.22H7.85312Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M6.3 14.14H7.84V17.22H6.3V14.14ZM5.88 19.18C5.88 19.6093 5.796 20.0107 5.628 20.384C5.46 20.7573 5.236 21.084 4.956 21.364C4.676 21.644 4.34933 21.8587 3.976 22.008C3.60267 22.176 3.20133 22.26 2.772 22.26H0V19.18H5.88ZM5.88 7.98V18.76H2.8V7.98H5.88ZM2.464 4.144L4.34 2.268L6.216 4.144L4.34 6.02L2.464 4.144Z"
            fill="var(--color-brand-primary)"
          />
        </svg>
      );

    case "white":
      return (
        <svg
          style={{ minHeight: getHeight, minWidth: getWidth }}
          className={className}
          onClick={handleClick}
          width={getWidth}
          height={getHeight}
          viewBox="0 0 79 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M74.127 11.6631V7.29492H69.082L66.7441 4.95703V2.3291L69.082 0H70.4004V4.13965H75.7617L78.0205 6.47754V9.33398L75.6914 11.6631H74.127ZM71.0156 2.10059V0H75.6826L77.7041 2.03027V3.26953H74.127V2.10059H71.0156ZM66.7441 8.16504H70.6289V9.55371H73.5117V11.6631H68.7041L66.7441 9.33398V8.16504Z"
            fill="white"
          />
          <path
            d="M55.7754 11.6631V0H59.6602V11.6631H55.7754ZM60.2754 11.6631V9.33398H62.2002V7.85742H65.7246V11.6631H60.2754Z"
            fill="white"
          />
          <path
            d="M50.2471 10.3887H46.4326L47.2412 8.07715H49.3506L46.2305 0H50.0186L54.668 11.6631H50.7393L50.2471 10.3887ZM45.3955 11.6631H41.6426L45.8086 0.527344L47.5312 5.15918L45.3955 11.6631Z"
            fill="white"
          />
          <path
            d="M26.3584 0H30.4893L33.6182 5.18555L36.0791 0.966797V6.83789L33.2754 11.6631L26.3584 0ZM36.6504 11.6631V0H40.5352V11.6631H36.6504ZM26.3496 11.6631V1.08105L29.9795 7.17188V11.6631H26.3496Z"
            fill="white"
          />
          <path
            d="M20.8213 10.3887H17.0068L17.8154 8.07715H19.9248L16.8047 0H20.5928L25.2422 11.6631H21.3135L20.8213 10.3887ZM15.9697 11.6631H12.2168L16.3828 0.527344L18.1055 5.15918L15.9697 11.6631Z"
            fill="white"
          />
          <path
            d="M3.88477 9.33398H7.21582V11.6631H2.3291L0 9.33398V2.3291L2.3291 0H3.88477V9.33398ZM5.94141 5.19434H11.2764V11.6631H7.83105V7.50586H5.94141V5.19434ZM4.5 2.3291V0H9.2373L11.2764 2.3291V3.49805H7.3916V2.3291H4.5Z"
            fill="white"
          />
        </svg>
      );

    case "white-ar":
      return (
        <svg
          style={{ minHeight: getHeight, minWidth: getWidth }}
          className={className}
          onClick={handleClick}
          width={getWidth}
          height={getHeight}
          viewBox="0 0 42 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.6186 14.98C26.6186 14.7373 26.7026 14.5413 26.8706 14.392C27.0199 14.224 27.2159 14.14 27.4586 14.14H41.2066C41.2066 14.5693 41.1226 14.9707 40.9546 15.344C40.8053 15.7173 40.5906 16.044 40.3106 16.324C40.0306 16.604 39.7039 16.828 39.3306 16.996C38.9573 17.1453 38.5559 17.22 38.1266 17.22H27.4586C27.2159 17.22 27.0199 17.1453 26.8706 16.996C26.7026 16.828 26.6186 16.6227 26.6186 16.38V14.98ZM33.9266 7.98L39.6666 13.72H35.3266L32.6386 11.06H28.8586V7.98H33.9266ZM32.0506 20.664L33.9266 18.788L35.8026 20.664L33.9266 22.54L32.0506 20.664Z"
            fill="white"
          />
          <path
            d="M16.8131 7.98H19.8931C20.7331 7.98 21.5265 8.148 22.2731 8.484C23.0198 8.80133 23.6731 9.24 24.2331 9.8C24.7931 10.36 25.2318 11.0133 25.5491 11.76C25.8851 12.5067 26.0531 13.3 26.0531 14.14V17.22H22.9731V14.14C22.9731 13.7107 22.8891 13.3093 22.7211 12.936C22.5718 12.5627 22.3571 12.236 22.0771 11.956C21.7971 11.676 21.4705 11.4613 21.0971 11.312C20.7238 11.144 20.3225 11.06 19.8931 11.06V13.72H16.8131V7.98ZM22.5531 14.14V17.22H14.8531C14.6105 17.22 14.4145 17.1453 14.2651 16.996C14.0971 16.828 14.0131 16.6227 14.0131 16.38V14.98C14.0131 14.7373 14.0971 14.5413 14.2651 14.392C14.4145 14.224 14.6105 14.14 14.8531 14.14H22.5531ZM26.4731 14.14H27.4531V17.22H26.4731V14.14Z"
            fill="white"
          />
          <path
            d="M9.81312 0H12.8931V13.72H9.81312V0ZM7.85312 17.22C7.61046 17.22 7.41446 17.1453 7.26512 16.996C7.09712 16.828 7.01312 16.6227 7.01312 16.38V14.98C7.01312 14.7373 7.09712 14.5413 7.26512 14.392C7.41446 14.224 7.61046 14.14 7.85312 14.14H14.8531V17.22H7.85312Z"
            fill="white"
          />
          <path
            d="M6.3 14.14H7.84V17.22H6.3V14.14ZM5.88 19.18C5.88 19.6093 5.796 20.0107 5.628 20.384C5.46 20.7573 5.236 21.084 4.956 21.364C4.676 21.644 4.34933 21.8587 3.976 22.008C3.60267 22.176 3.20133 22.26 2.772 22.26H0V19.18H5.88ZM5.88 7.98V18.76H2.8V7.98H5.88ZM2.464 4.144L4.34 2.268L6.216 4.144L4.34 6.02L2.464 4.144Z"
            fill="white"
          />
        </svg>
      );

    case "blue-on-white":
      return (
        <svg
          style={{ minHeight: getHeight, minWidth: getWidth }}
          className={className}
          onClick={handleClick}
          width={getWidth}
          height={getHeight}
          viewBox="0 0 100 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 16C0 7.16344 7.16344 0 16 0H84C92.8366 0 100 7.16344 100 16V24C100 32.8366 92.8366 40 84 40H16C7.16345 40 0 32.8366 0 24V16Z"
            fill="white"
          />
          <path
            d="M85.1167 25.8315V21.4634H80.0718L77.7339 19.1255V16.4976L80.0718 14.1685H81.3901V18.3081H86.7515L89.0103 20.646V23.5024L86.6812 25.8315H85.1167ZM82.0054 16.269V14.1685H86.6724L88.6938 16.1987V17.438H85.1167V16.269H82.0054ZM77.7339 22.3335H81.6187V23.7222H84.5015V25.8315H79.6938L77.7339 23.5024V22.3335Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M66.7651 25.8315V14.1685H70.6499V25.8315H66.7651ZM71.2651 25.8315V23.5024H73.1899V22.0259H76.7144V25.8315H71.2651Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M61.2368 24.5571H57.4224L58.231 22.2456H60.3403L57.2202 14.1685H61.0083L65.6577 25.8315H61.729L61.2368 24.5571ZM56.3853 25.8315H52.6323L56.7983 14.6958L58.521 19.3276L56.3853 25.8315Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M37.3481 14.1685H41.479L44.6079 19.354L47.0688 15.1353V21.0063L44.2651 25.8315L37.3481 14.1685ZM47.6401 25.8315V14.1685H51.5249V25.8315H47.6401ZM37.3394 25.8315V15.2495L40.9692 21.3403V25.8315H37.3394Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M31.811 24.5571H27.9966L28.8052 22.2456H30.9146L27.7944 14.1685H31.5825L36.2319 25.8315H32.3032L31.811 24.5571ZM26.9595 25.8315H23.2065L27.3726 14.6958L29.0952 19.3276L26.9595 25.8315Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M14.8745 23.5024H18.2056V25.8315H13.3188L10.9897 23.5024V16.4976L13.3188 14.1685H14.8745V23.5024ZM16.9312 19.3628H22.2661V25.8315H18.8208V21.6743H16.9312V19.3628ZM15.4897 16.4976V14.1685H20.2271L22.2661 16.4976V17.6665H18.3813V16.4976H15.4897Z"
            fill="var(--color-brand-primary)"
          />
        </svg>
      );

    case "blue-on-white-ar":
      return (
        <svg
          style={{ minHeight: getHeight, minWidth: getWidth }}
          className={className}
          onClick={handleClick}
          width={getWidth}
          height={getHeight}
          viewBox="0 0 100 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 16C0 7.16344 7.16344 0 16 0H84C92.8366 0 100 7.16344 100 16V24C100 32.8366 92.8366 40 84 40H16C7.16345 40 0 32.8366 0 24V16Z"
            fill="white"
          />
          <path
            d="M56.0151 23.71C56.0151 23.4673 56.0991 23.2713 56.2671 23.122C56.4164 22.954 56.6124 22.87 56.8551 22.87H70.6031C70.6031 23.2993 70.5191 23.7006 70.3511 24.074C70.2017 24.4473 69.9871 24.774 69.7071 25.054C69.4271 25.334 69.1004 25.558 68.7271 25.726C68.3537 25.8753 67.9524 25.95 67.5231 25.95H56.8551C56.6124 25.95 56.4164 25.8753 56.2671 25.726C56.0991 25.558 56.0151 25.3526 56.0151 25.11V23.71ZM63.3231 16.71L69.0631 22.45H64.7231L62.0351 19.79H58.2551V16.71H63.3231ZM61.4471 29.394L63.3231 27.518L65.1991 29.394L63.3231 31.27L61.4471 29.394Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M46.2096 16.71H49.2896C50.1296 16.71 50.9229 16.878 51.6696 17.214C52.4163 17.5313 53.0696 17.97 53.6296 18.53C54.1896 19.09 54.6283 19.7433 54.9456 20.49C55.2816 21.2366 55.4496 22.03 55.4496 22.87V25.95H52.3696V22.87C52.3696 22.4406 52.2856 22.0393 52.1176 21.666C51.9683 21.2926 51.7536 20.966 51.4736 20.686C51.1936 20.406 50.8669 20.1913 50.4936 20.042C50.1203 19.874 49.7189 19.79 49.2896 19.79V22.45H46.2096V16.71ZM51.9496 22.87V25.95H44.2496C44.0069 25.95 43.8109 25.8753 43.6616 25.726C43.4936 25.558 43.4096 25.3526 43.4096 25.11V23.71C43.4096 23.4673 43.4936 23.2713 43.6616 23.122C43.8109 22.954 44.0069 22.87 44.2496 22.87H51.9496ZM55.8696 22.87H56.8496V25.95H55.8696V22.87Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M39.2096 8.72998H42.2896V22.45H39.2096V8.72998ZM37.2496 25.95C37.0069 25.95 36.8109 25.8753 36.6616 25.726C36.4936 25.558 36.4096 25.3526 36.4096 25.11V23.71C36.4096 23.4673 36.4936 23.2713 36.6616 23.122C36.8109 22.954 37.0069 22.87 37.2496 22.87H44.2496V25.95H37.2496Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M35.6965 22.87H37.2365V25.95H35.6965V22.87ZM35.2765 27.91C35.2765 28.3393 35.1925 28.7406 35.0245 29.114C34.8565 29.4873 34.6325 29.814 34.3525 30.094C34.0725 30.374 33.7458 30.5886 33.3725 30.738C32.9992 30.906 32.5978 30.99 32.1685 30.99H29.3965V27.91H35.2765ZM35.2765 16.71V27.49H32.1965V16.71H35.2765ZM31.8605 12.874L33.7365 10.998L35.6125 12.874L33.7365 14.75L31.8605 12.874Z"
            fill="var(--color-brand-primary)"
          />
        </svg>
      );

    case "white-on-blue":
      return (
        <svg
          style={{ minHeight: getHeight, minWidth: getWidth }}
          className={className}
          onClick={handleClick}
          width={getWidth}
          height={getHeight}
          viewBox="0 0 100 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 16C0 7.16344 7.16344 0 16 0H84C92.8366 0 100 7.16344 100 16V24C100 32.8366 92.8366 40 84 40H16C7.16345 40 0 32.8366 0 24V16Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M85.1167 25.8315V21.4634H80.0718L77.7339 19.1255V16.4976L80.0718 14.1685H81.3901V18.3081H86.7515L89.0103 20.646V23.5024L86.6812 25.8315H85.1167ZM82.0054 16.269V14.1685H86.6724L88.6938 16.1987V17.438H85.1167V16.269H82.0054ZM77.7339 22.3335H81.6187V23.7222H84.5015V25.8315H79.6938L77.7339 23.5024V22.3335Z"
            fill="white"
          />
          <path
            d="M66.7651 25.8315V14.1685H70.6499V25.8315H66.7651ZM71.2651 25.8315V23.5024H73.1899V22.0259H76.7144V25.8315H71.2651Z"
            fill="white"
          />
          <path
            d="M61.2368 24.5571H57.4224L58.231 22.2456H60.3403L57.2202 14.1685H61.0083L65.6577 25.8315H61.729L61.2368 24.5571ZM56.3853 25.8315H52.6323L56.7983 14.6958L58.521 19.3276L56.3853 25.8315Z"
            fill="white"
          />
          <path
            d="M37.3481 14.1685H41.479L44.6079 19.354L47.0688 15.1353V21.0063L44.2651 25.8315L37.3481 14.1685ZM47.6401 25.8315V14.1685H51.5249V25.8315H47.6401ZM37.3394 25.8315V15.2495L40.9692 21.3403V25.8315H37.3394Z"
            fill="white"
          />
          <path
            d="M31.811 24.5571H27.9966L28.8052 22.2456H30.9146L27.7944 14.1685H31.5825L36.2319 25.8315H32.3032L31.811 24.5571ZM26.9595 25.8315H23.2065L27.3726 14.6958L29.0952 19.3276L26.9595 25.8315Z"
            fill="white"
          />
          <path
            d="M14.8745 23.5024H18.2056V25.8315H13.3188L10.9897 23.5024V16.4976L13.3188 14.1685H14.8745V23.5024ZM16.9312 19.3628H22.2661V25.8315H18.8208V21.6743H16.9312V19.3628ZM15.4897 16.4976V14.1685H20.2271L22.2661 16.4976V17.6665H18.3813V16.4976H15.4897Z"
            fill="white"
          />
        </svg>
      );

    case "white-on-blue-ar":
      return (
        <svg
          style={{ minHeight: getHeight, minWidth: getWidth }}
          className={className}
          onClick={handleClick}
          width={getWidth}
          height={getHeight}
          viewBox="0 0 100 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 16C0 7.16344 7.16344 0 16 0H84C92.8366 0 100 7.16344 100 16V24C100 32.8366 92.8366 40 84 40H16C7.16345 40 0 32.8366 0 24V16Z"
            fill="var(--color-brand-primary)"
          />
          <path
            d="M56.0151 23.71C56.0151 23.4673 56.0991 23.2713 56.2671 23.122C56.4164 22.954 56.6124 22.87 56.8551 22.87H70.6031C70.6031 23.2993 70.5191 23.7006 70.3511 24.074C70.2017 24.4473 69.9871 24.774 69.7071 25.054C69.4271 25.334 69.1004 25.558 68.7271 25.726C68.3537 25.8753 67.9524 25.95 67.5231 25.95H56.8551C56.6124 25.95 56.4164 25.8753 56.2671 25.726C56.0991 25.558 56.0151 25.3526 56.0151 25.11V23.71ZM63.3231 16.71L69.0631 22.45H64.7231L62.0351 19.79H58.2551V16.71H63.3231ZM61.4471 29.394L63.3231 27.518L65.1991 29.394L63.3231 31.27L61.4471 29.394Z"
            fill="white"
          />
          <path
            d="M46.2096 16.71H49.2896C50.1296 16.71 50.9229 16.878 51.6696 17.214C52.4163 17.5313 53.0696 17.97 53.6296 18.53C54.1896 19.09 54.6283 19.7433 54.9456 20.49C55.2816 21.2366 55.4496 22.03 55.4496 22.87V25.95H52.3696V22.87C52.3696 22.4406 52.2856 22.0393 52.1176 21.666C51.9683 21.2926 51.7536 20.966 51.4736 20.686C51.1936 20.406 50.8669 20.1913 50.4936 20.042C50.1203 19.874 49.7189 19.79 49.2896 19.79V22.45H46.2096V16.71ZM51.9496 22.87V25.95H44.2496C44.0069 25.95 43.8109 25.8753 43.6616 25.726C43.4936 25.558 43.4096 25.3526 43.4096 25.11V23.71C43.4096 23.4673 43.4936 23.2713 43.6616 23.122C43.8109 22.954 44.0069 22.87 44.2496 22.87H51.9496ZM55.8696 22.87H56.8496V25.95H55.8696V22.87Z"
            fill="white"
          />
          <path
            d="M39.2096 8.72998H42.2896V22.45H39.2096V8.72998ZM37.2496 25.95C37.0069 25.95 36.8109 25.8753 36.6616 25.726C36.4936 25.558 36.4096 25.3526 36.4096 25.11V23.71C36.4096 23.4673 36.4936 23.2713 36.6616 23.122C36.8109 22.954 37.0069 22.87 37.2496 22.87H44.2496V25.95H37.2496Z"
            fill="white"
          />
          <path
            d="M35.6965 22.87H37.2365V25.95H35.6965V22.87ZM35.2765 27.91C35.2765 28.3393 35.1925 28.7406 35.0245 29.114C34.8565 29.4873 34.6325 29.814 34.3525 30.094C34.0725 30.374 33.7458 30.5886 33.3725 30.738C32.9992 30.906 32.5978 30.99 32.1685 30.99H29.3965V27.91H35.2765ZM35.2765 16.71V27.49H32.1965V16.71H35.2765ZM31.8605 12.874L33.7365 10.998L35.6125 12.874L33.7365 14.75L31.8605 12.874Z"
            fill="white"
          />
        </svg>
      );
  }
}
